import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.083 12.5h2.5a.625.625 0 0 0 0-1.25h-2.5a.625.625 0 0 0 0 1.25m-4.166-.625a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333m7.916-7.5H4.167c-.92 0-1.667.746-1.667 1.667v8.333c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V6.042c0-.92-.747-1.667-1.667-1.667m.417 10c0 .23-.187.417-.417.417h-5c0-1.15-.932-2.084-2.083-2.084H7.083A2.083 2.083 0 0 0 5 14.792h-.833a.417.417 0 0 1-.417-.417V7.708h12.5zm-4.167-3.958h2.5a.625.625 0 0 0 0-1.25h-2.5a.625.625 0 0 0 0 1.25"
    }, null, -1)
  ]))]))
}
export default { render: render }